<template>
  <mdb-container class="limiter" style="padding-left: 0rem; padding-right: 0rem;">
    <div class="container-password100">
      <div class="logo2">
        <img src="../../static/LogoMyfrac@2x.png" />
      </div>
      <div class="wrap-password100">
        <div class="recuperar100-form">
          <div class="logo">
            <img src="../../static/RecoveryCountText@3x.png" />
          </div>
          <br />

          <div v-if="responseSuccess" class="BloqueSuccess">
            <div
              class="texto"
            >Un correo ya ha sido enviado exitosamente a tu cuenta con las indicaciones para que puedas recuperar o restablecer tu contraseña.</div>
            <div class="imagen">
              <img src="../../static/icon-revovery-success.png" />
            </div>
            <div class="col-md-12">
              <a
                href="/"
                class="center-block btn btn-blue"
                style="height: auto !important;"
              >Ir a MYFRAC</a>
            </div>
            <div class="clearfix"></div>
          </div>
          <div v-if="responseError" class="alert alert-danger alert-dismissible" role="alert">
            <button type="button"  @click="reloadForm()" class="close" data-dismiss="alert">×</button>
            <strong>
              <i class="icon fa fa-ban"></i> Error
            </strong> su solicitud no puede ser procesada
            <strong>
              <a  @click="reloadForm()" class="btnClose alert-link">Intentar nuevamente</a>
            </strong>.
          </div>
          <div v-if="principalForm">
            <div
              class="form-group has-feedback wrap-input100"
              :class="{ 'has-error': hasErrorUsername }"
            >
              <input
                class="input100"
                type="email"
                name="email"
                placeholder="Correo electrónico"
                id="emailReset"
                v-model="loginUser"
                @keyup="keymonitor"
              />
              <span class="symbol-input100Error" v-show="hasErrorUsername">
                <i class="fa fa-envelope" aria-hidden="true"></i>
              </span>
              <span class="symbol-input100" v-show="!hasErrorUsername">
                <i class="fa fa-envelope" aria-hidden="true"></i>
              </span>
              <span class="focus-input100"></span>
              <span class="help-block" v-show="hasErrorUsername">
                <strong>El campo es obligatorio.</strong>
              </span>
            </div>

            <div class="container-login100-form-btn">
              <button
                type="submit"
                class="login100-form-btn getPassword"
                @click="resetPassword()"
              >Recuperar Contraseña</button>
            </div>
            <div class="text-center" style="padding-top: 12px;">
              <i class="fa fa-arrow-circle-left" aria-hidden="true">
                <a class="txt2" href="/">Volver al inicio</a>
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Servers from "../../server.js";
import { mdbContainer } from "mdbvue";

export default {
  name: "resetPassword",
  components: {
    mdbContainer
  },
  data() {
    return {
      principalForm: true,
      responseSuccess: false,
      responseError: false,
      loginUser: "",
      hasErrorUsername: false,
     
    
    };
  },
  mounted() {},
  methods: {
      reloadForm(){
          this.principalForm=true;
        this.responseSuccess=false;
      this.responseError=false;
      this.loginUser= "";
      this.hasErrorUsername=false;


      },
      keymonitor: function(event) {
      if (event.keyCode == 13) {
        this.resetPassword();
      }
      if (this.loginUser === "") {
        this.hasErrorUsername = true;
      } else {
        this.hasErrorUsername = false;
      }

    },
    resetPassword(){
        let aux = this;
         if (this.loginUser != "") {
        
        Axios.post(Servers.serverApi + "/api/users/resetPassword", aux.loginUser, {
          headers: {
            "Content-Type": "text/plain",
            Authorization:
              "Basic bXlmcmFjLW1vYmlsZTpLMXJpdDNrTXlGcjRjUGw0dGZvcm0="
          }
        }).then(
          function(response) {
              aux.responseSuccess = true
              aux.responseError = false
            
          },
          function(error) {
              aux.responseError = true
              aux.responseSuccess = false
           
          }
        );
      } else {
        aux.hasErrorUsername = true;
        aux.responseError = true
      }
      aux.principalForm = false 

    }
  }
};
</script>

<style scoped>
/* --------------------------------------------------------
 /* ---- PAGINA - USUARIOS
 -------------------------------------------------------- */
body {
  background: #4eaeff !important;
  border: 0px !important;
  margin: 0px !important;
  padding: 0px !important;
}

html {
  border: 0px !important;
  margin: 0px !important;
  padding: 0px !important;
}

.loginBGImage {
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0px;
  z-index: -1;
}

.loginBGImage img {
  width: 100%;
  height: auto;
}

.loginBGImage2 {
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0px;
  z-index: -1;
  bottom: 10%;
  right: 0%;
}

.login-page {
  z-index: 9999;
}

.login-box-custom {
  width: 375px !important;
  height: auto !important;
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -30%);
  -webkit-transform: translate(-50%, -30%);
  
}

.login-box-custom > .imagenLogo {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.login-box-custom > .imagenLogo img {
  width: 100%;
  height: auto;
}

.login-box-body-custom {
  min-height: 255px !important;
  border-radius: 6px !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}

.login-box-body-custom > .bloqueTexto {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
}

.login-box-body-custom > .bloqueTexto img {
  width: 100%;
  height: auto;
}

.email-custom {
  border-radius: 25px !important;
  background-color: #ffffff !important;
  border: solid 2px #2699fb !important;
  height: 46px;
  font-size: 13px !important;
  color: #2699fb !important;
}

.email-custom::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 13px !important;
  color: #2699fb !important;
}

.email-custom:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 13px !important;
  color: #2699fb !important;
}

.email-custom::-ms-input-placeholder {
  /* Microsoft Edge */
  font-size: 13px !important;
  color: #2699fb !important;
}

.custom-mail-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 10px;
  top: 10px;
}

.custom-mail-icon img {
  width: 100%;
  height: auto;
}

.custom-btn-recuperar {
  width: 148px;
  height: 48px;
  background: rgba(0, 0, 0, 0);
}

.custom-btn-recuperar img {
  width: 100%;
  height: auto;
}

.help-block {
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  color: #4298de !important;
  font-family: Poppins-Regular;
}

.BloqueSuccess {
  width: 100%;
  height: auto;
  position: relative;
  border-top: 1px solid #4298de;
}

.BloqueSuccess > .texto {
  width: 100%;
  height: auto;
  padding: 10px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #4298de;
  margin-bottom: 20px;
}

.BloqueSuccess > .imagen {
  width: 188px;
  height: 134px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.BloqueSuccess > .imagen img {
  width: 100%;
  height: auto;
}

.limiter {
  max-width: 100% !important;
}

.container-password100 {
  width: 100%;  
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 30px;
  background: #4eaeff;
  background-image: url('../../static/fondoRecoveryPass-1@3x.png');
  background-position: bottom;
  background-size: 100%;
  background-repeat: no-repeat;
}



.wrap-password100 {
  width: 500px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 50px 50px 50px 50px;
}

.recuperar100-form{
  width: auto;
}

.logo{
  width: 100%;
  height: auto;
}

.logo img{
  width: 70%;
  height: auto;
  margin: 0 50px;
}

.logo2{
  width: 100%;
  height: auto;
  padding: 0px 220px
}

.logo2 img{
  width: 20%;
  height: auto;
  margin: 10% 30% 2% 40%
}

.wrap-input100 {
  position: relative;
  width: 100%;
  z-index: 1;
  margin-bottom: 10px;
}


.input100 {
  font-family: "OpenSans-Regular";
  font-size: 15px;
  line-height: 1.5;
  color: #666666;

  display: block;
  width: 100%;
  background: #e6e6e6;
  height: 50px;
  border-radius: 25px;
  padding: 0 30px 0 68px;
}


.focus-input100 {
  display: block;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 0px 0px;
  color: rgba(66,152,222, 0.8);
}

.input100:focus + .focus-input100 {
  -webkit-animation: anim-shadow 0.5s ease-in-out forwards;
  animation: anim-shadow 0.5s ease-in-out forwards;
}

@-webkit-keyframes anim-shadow {
  to {
    box-shadow: 0px 0px 70px 25px;
    opacity: 0;
  }
}

@keyframes anim-shadow {
  to {
    box-shadow: 0px 0px 70px 25px;
    opacity: 0;
  }
}

.symbol-input100 {
  font-size: 15px;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 35px;
  pointer-events: none;
  color: #666666;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.symbol-input100Error {
  font-size: 15px;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  top: -12px;
  width: 100%;
  height: 100%;
  padding-left: 35px;
  pointer-events: none;
  color: #666666;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.input100:focus + .focus-input100 + .symbol-input100 +.symbol-input100Error {
  color: #002746;
  padding-left: 28px;
}


/*------------------------------------------------------------------
[ Button ]*/
.container-login100-form-btn {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 20px;
  font-family: "OpenSans-Regular";
}

.login100-form-btn {
  font-family: "OpenSans-Bold";
  font-size: 15px;
  line-height: 1.5;
  color: #fff;
  text-transform: uppercase;

  width: 100%;
  height: 50px;
  border-radius: 25px;
  background: #2b9bfb;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 25px;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.login100-form-btn:hover {
  background: #333333;
}

.txt2 {
  font-family: "OpenSans-Regular";
  font-size: 13px;
  line-height: 1.5;
  color: #666666;
}



/*------------------------------------------------------------------
[ Responsive ]*/



@media (max-width: 992px) {
  .wrap-login100 {
    padding: 177px 90px 33px 85px;
  }

  .wrap-password100{
    /*padding: 80px 80px 80px 80px;*/
    padding: 177px 90px 33px 85px;
  }

  .login100-pic {
    width: 35%;
  }

  .login100-form {
    width: 50%;
    margin-top: -10%
  }

  .recuperar100-form{
    width: 100%;
    margin-top: -10%;
  }
}

@media (max-width: 1440px){

  .logo2 img{
    width: 50%;
    height: auto;
    margin: 10% 10% 2% 26%
  }
}

@media (max-width: 1024px) {
  
  .logo2 img{
    width: 45%;
    height: auto;
    margin: 300px 135px 15px;
  }
  
}

@media (max-width: 768px) {
  .container-login100 {
    padding: 15px 128px;
  }
  .wrap-login100 {
    padding: 100px 80px 33px 80px;
  }

  .wrap-password100{
    /*padding: 60px 60px 60px 60px;*/
    padding: 80px 80px 33px 80px;
  }

  .login100-pic {
    display: none;
  }

  .login100-form {
    width: 350px;
  }
  .recuperar100-form{
    width: 350px;
  }

  .logo2 img{
    width: 80%;
    height: auto;
    margin: 300px 30px 20px;
  }

  .logo img{
    width: 90%;
    height: auto;
    margin: 0px 15px;
  }
}
@media (max-width: 425px){
  .container-login100 {
    padding: 15px 30px;
  }
}

@media (max-width: 576px) {
  .wrap-login100 {
    padding: 100px 15px 33px 15px;
  }
  .wrap-password100{
    /*padding: 40px 40px 40px 40px*/
    padding: 60px 15px 33px 15px;
  }
  .logo img{
    width: 90%;
    height: auto;
    margin: 0px 15px;
  }

  .logo2 img{
    width: 150px;
    height: auto;
    margin: 400px -72px -10px;
  }
  
}

</style>